import React, { useState, useEffect } from "react";
import { Layout, Menu, Affix, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import LogoOriginal from "../img/logo.png";

const { Header } = Layout;

export const NavInfraestructura = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    closeDrawer();
  };


  const menuItems = [
    { key: "1", label: <a href="/">Inicio</a> },
    { key: "2", label: <a href="/desarrollo">Desarrollo</a> },
    {
      key: "3",
      label: <a onClick={() => handleScroll("serviciosInfraestructura")}>Servicios</a>,
    },
    {
      key: "4",
      label: <a onClick={() => handleScroll("integraciones")}>Integraciones</a>,
    },
    {
      key: "5",
      label: (
        <a onClick={() => handleScroll("productosInfraestructura")}>Producto</a>
      ),
    },
  ];

  return (
    <Affix>
      <Header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={LogoOriginal} alt="Logo" />
          </Link>
        </div>

        {/* Menú para escritorio */}
        {!isMobile && (
          <div className="menu-desktop">
            <Menu mode="horizontal" items={menuItems} />
          </div>
        )}

        {/* Menú para teléfono */}
        {isMobile && (
          <div className="menu-mobile">
            <Button
              type="text"
              icon={<MenuOutlined className="icono-menu-mobile" />}
              onClick={showDrawer}
              aria-label="Abrir menú de navegación"
            />
          </div>
        )}

        {/* Drawer para teléfono */}
        <Drawer placement="right" onClose={closeDrawer} open={isDrawerOpen}>
          <Menu mode="vertical" items={menuItems} onClick={closeDrawer}/>
        </Drawer>
      </Header>
    </Affix>
  );
};
